import { Injectable } from '@angular/core';
import { StorageService } from '@app/services/storage';
import { GeneralApiService, StatusApi } from '@global-service/api';
import { ActividadComercial, ErrorDesactivarSociedad, Municipio, Pais, RegimenFiscal, Sociedad, TipoIdentificacion } from '../interfaces';

@Injectable()
export class SociedadService {
  constructor(private readonly generalApi: GeneralApiService, private readonly storageService: StorageService) {}

  get(sociedad_id: number, loading?: StatusApi) {
    return this.generalApi.callApi<Sociedad>('get', `/empresa/${this.storageService.getEmpresaID()}/sociedad/${sociedad_id}`, {
      loading,
      toastError: 'No existe la sociedad con id: ' + sociedad_id,
    });
  }
  update(sociedad: Partial<Sociedad>, loading?: StatusApi) {
    return this.generalApi.callApi<{ sociedad_id: number }>('post', `/empresa/${this.storageService.getEmpresaID()}/sociedad/update`, {
      postData: sociedad,
      loading,
      toastSuccess: `Sociedad ${sociedad.sociedad_id ? 'actualizada' : 'creada'} correctamente`,
    });
  }
  async activar(sociedad_id: number) {
    try {
      await this.generalApi.callApi<{ sociedad_id: number }>('post', `/empresa/${this.storageService.getEmpresaID()}/sociedad/${sociedad_id}/activar`);
      return true;
    } catch (error) {
      return false;
    }
  }
  async desactivar(sociedad_id: number): Promise<{ esOk: boolean; error?: ErrorDesactivarSociedad }> {
    try {
      await this.generalApi.callApi<{ sociedad_id: number }>('post', `/empresa/${this.storageService.getEmpresaID()}/sociedad/${sociedad_id}/desactivar`);
      return { esOk: true };
    } catch (error) {
      const data = error && typeof error === 'object' && 'data' in error ? error.data : undefined;
      return { esOk: false, error: data as ErrorDesactivarSociedad | undefined };
    }
  }
  listadoProvinciasPorPais(loading?: StatusApi) {
    return this.generalApi.callApi<Pais>('get', `/empresa/${this.storageService.getEmpresaID()}/PaisVsProvincias`, {
      loading,
    });
  }
  listadoMunicipiosPorPaisYProvincia(loading: StatusApi, paisId: string, provinciaId: number) {
    return this.generalApi.callApi<Municipio[]>('get', `/municipios/${paisId}/${provinciaId}`, {
      loading,
    })
  }
  listadoRegimenesFiscales(loading?: StatusApi) { 
    return this.generalApi.callApi<RegimenFiscal[]>('get', `/empresa/${this.storageService.getEmpresaID()}/regimenesFiscales`, {
      loading,
      keyResult: null // Mantener hasta que el backend devuelva los resultados dentro de "data".
    });
  }
  listadoActividadesComerciales(loading?: StatusApi) {
    return this.generalApi.callApi<ActividadComercial[]>('get', `/empresa/${this.storageService.getEmpresaID()}/actividadesComerciales`, { loading });
  }
  getTiposIdentificacion(loading?: StatusApi) {
    return this.generalApi.callApi<TipoIdentificacion[]>('get', `/empresa/${this.storageService.getEmpresaID()}/listarTipoIdentificacionStd`, {
      loading,
    });
  }
}
